<style src="./Reversal.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="searchCredits">
        <div class="row formcontainer">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-12">Veículo</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="ABC-1234"
                  class="form-control"
                  v-model="form.licencePlate"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-md-12">Colaborador</label>
              <div class="col-md-12">
                <select class="form-control" v-model="form.employee">
                  <option value>Todos</option>
                  <option
                    v-for="(item, idx) in employeeList"
                    :key="idx"
                    :value="item.userToken"
                  >
                    {{ item.fullName }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-sm-6">Motivo</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="Descreva o motivo da reversão da venda"
                  class="form-control"
                  v-model="form.reason"
                />
              </div>
            </div>
            <div class="text-center">
              <button
                class="btn btn-lg btn-primary"
                type="button"
                v-if="resultList.length > 0"
                @click="createMultipleReversal"
              >
                <!-- <i class="fa fa-search"></i> -->
                Estornar todos listados
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <th>Pago</th>
          <th>Data</th>
          <th>Hora</th>
          <th>Placa</th>
          <th>Valor</th>
          <th></th>
        </thead>
        <tbody>
          <tr class="read" v-for="(item, idx) in resultList" :key="idx">
            <td>{{ item.settled ? 'Pago' : 'Não Pago' }}</td>
            <td>{{ item.createdAt | fillDate }}</td>
            <td>{{ item.createdAt | fillTime }}</td>
            <td>{{ item.vehicle.licencePlate }}</td>
            <td>{{ item.amountPaid }}</td>
            <td>
              <button class="reverseButton" @click="createReversal(item)">
                Estornar
              </button>
              <button
                v-if="item.settled"
                class="reverseButton"
                @click="revertCredit(item)"
              >
                Reverter
              </button>
              <button
                class="deleteButton"
                @click="deleteCredit(item)"
                v-if="hasPermissionToRemove"
              >
                Apagar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group paginatecontent">
        <button
          class="btn btn-light btn-sm paginatebutton"
          :disabled="paginateHasPageLeft"
          @click="previousPage"
        >
          <i class="fa fa-arrow-left" />
        </button>
        <button
          class="btn btn-light btn-sm paginatebutton"
          :disabled="paginateHasPageRight"
          @click="nextPage"
        >
          <i class="fa fa-arrow-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      form: {
        licencePlate: '',
        employee: '',
        reason: '',
      },
      employeeList: [],
      resultList: [],
      showSpinner: false,
      paginate: {
        hasPageLeft: false,
        hasPageRight: false,
        countRegister: 0,
        pageSkip: 0,
        pageLimit: 100,
      },
    };
  },
  computed: {
    hasPermissionToRemove() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'vehicle-reversal-remove',
        'SHOW',
      );
    },
    paginateHasPageLeft() {
      return !(this.paginate.pageSkip - this.paginate.pageLimit >= 0);
    },
    paginateHasPageRight() {
      return !(
        this.paginate.pageSkip + this.paginate.pageLimit <
        this.paginate.countRegister
      );
    },
  },
  filters: {
    fillDate(value) {
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      return new Date(value).toLocaleTimeString('pt-BR');
    },
  },
  mounted() {
    this.listEmployees();
  },
  methods: {
    async listEmployees() {
      const employeeListFull = await this.$store.dispatch(
        'EMPLOYEE/GetEmployeeList',
      );
      const employeeList = employeeListFull.map(item => ({
        id: item.userToken,
        userToken: item.userToken,
        fullName: item.fullName,
        shiftSelected: 0,
      }));

      this.employeeList = employeeList;
    },
    async searchCredits() {
      // this.paginate.pageSkip = 0;
      this.requestList();
    },
    async requestList() {
      try {
        this.showSpinner = true;
        const reversalList = await this.$store.dispatch(
          'PAYMENT/GetReversalList',
          {
            licencePlate: this.form.licencePlate || undefined,
            employeeToken: this.form.employee || undefined,
            pageSkip: this.paginate.pageSkip,
            pageLimit: this.paginate.pageLimit,
          },
        );
        this.resultList = reversalList.list;
        this.paginate.countRegister = reversalList.count;
      } catch (error) {
        this.$toasted.error('Não foi possível Listar');
      } finally {
        this.showSpinner = false;
      }
    },
    async createReversal(credit) {
      if (this.form.reason.length === 0) {
        return this.$toasted.error('Preencha o motivo.');
      }
      this.showSpinner = true;
      const reversalInfo = {
        status: 2,
        reason: this.form.reason,
      };
      try {
        await this.$store.dispatch('PAYMENT/CreateReversal', {
          creditId: credit._id,
          reversalInfo,
        });
        this.$toasted.success('Estorno realizado.');
        this.searchCredits();
      } catch (error) {
        console.error(error);
        this.$toasted.error('Não foi possível realizar o estorno');
      } finally {
        this.showSpinner = false;
      }
    },
    async createMultipleReversal() {
      if (this.form.reason.length === 0) {
        return this.$toasted.error('Preencha o motivo.');
      }
      this.showSpinner = true;
      const reversalInfo = {
        status: 2,
        reason: this.form.reason,
      };
      const credits = this.resultList.map(item => item._id);
      try {
        await this.$store.dispatch('PAYMENT/CreateMultipleReversal', {
          credits,
          reversalInfo,
        });

        this.$toasted.success('Estorno realizado.');
        this.searchCredits();
      } catch (error) {
        console.error(error);
        this.$toasted.error('Não foi possível realizar o estorno');
      } finally {
        this.showSpinner = false;
      }
    },
    async revertCredit(credit) {
      if (this.form.reason.length === 0) {
        return this.$toasted.error('Preencha o motivo.');
      }
      const payload = {
        reversalInfo: {
          reason: this.form.reason,
        },
        creditId: credit._id,
      };

      this.showSpinner = true;
      try {
        await this.$store.dispatch('PAYMENT/ReverseCredit', payload);
        this.$toasted.success('Venda revertida.');
        // this.searchCredits();
      } catch (error) {
        this.$toasted.error('Não foi possível reverter a venda');
      } finally {
        this.showSpinner = false;
      }
    },
    async deleteCredit(credit) {
      if (this.form.reason.length === 0) {
        this.$toasted.error('É necessário preenceher o motivo.');
        return;
      }
      try {
        this.showSpinner = true;
        await this.$store.dispatch('PAYMENT/CreateCourtesy', {
          creditId: credit._id,
          reason: this.form.reason,
        });
        this.$toasted.success('Venda apagada.');
        // this.searchCredits();
      } catch (error) {
        this.$toasted.error('Não foi possível apagar a venda');
      } finally {
        this.showSpinner = false;
      }
    },
    previousPage() {
      this.paginate.pageSkip -= this.paginate.pageLimit;
      this.requestList();
    },
    nextPage() {
      this.paginate.pageSkip += this.paginate.pageLimit;
      this.requestList();
    },
  },
};
</script>
